module.exports = __webpack_public_path__ + "img/banner2-2@1x.e2bd6455.jpg";